import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconStrikethrough",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, l, m, _, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--strikethrough"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Strikethrough",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    i("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.5 1.5H8a.5.5 0 1 1 0 1H4.5a1.001 1.001 0 0 0-.943 1.333.5.5 0 1 1-.943.334A2 2 0 0 1 4.5 1.5Z",
      fill: "currentColor"
    }, null, -1),
    i("path", {
      d: "M9.5 8A2.5 2.5 0 0 1 7 10.5H3a.5.5 0 0 1 0-1h4a1.5 1.5 0 0 0 0-3H2a.5.5 0 0 1 0-1h8a.5.5 0 1 1 0 1H9c.323.43.5.956.5 1.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const S = /* @__PURE__ */ s(c, [["render", h]]);
export {
  S as default
};
//# sourceMappingURL=strikethrough.js.map
